= 'Patient ' + patid + ' '
button.btn.btn-xs.btn-default.btn-copy(type='button', data-clipboard-text=nhs, data-content='Copied!<br><strong>Use Ctrl + v to paste into ' + selectedPractice.ehr + '!</strong>', data-toggle='lone-tooltip', data-placement='right', title='Copy ' + nhs + ' to clipboard.')
  span.far.fa-copy
= ' - ' + age + ' year old ' + sex
